import React, { memo } from 'react';
import { v1 as uuid } from 'uuid';
import { TagChipItem, QuestionTagsWrapper } from './styles';
import { ITagView } from 'store/providers/providerTypes';

interface IComponentProps {
  questionTags: ITagView[];
}

const RelatedResponsesQuestionTags: React.FC<IComponentProps> = ({
  questionTags,
}) => (
  <QuestionTagsWrapper>
    {questionTags.map((tag) => (
      <TagChipItem key={uuid()} size={6} color="gray">
        {tag.text}
      </TagChipItem>
    ))}
  </QuestionTagsWrapper>
);

export default memo(RelatedResponsesQuestionTags);
